<template>
  <div>
    <div>
      {{ $t("label_administration_wizard_createNewTags_tagName") }}:&nbsp;
      <b v-if="tagIndex === 0">{{ tagToCreate.name }}</b>
      <div>
        <input
          v-if="tagIndex > 0"
          style="width: 100%"
          :value="tagToCreate.name"
          @input="
            setTagToCreate(tagToCreate, 'name', $event.target.value, tagIndex)
          "
        />
      </div>
      <div>
        <b v-if="tagIndex === 0">
          {{$t("label_administration_wizard_newTagAddedAutomaticallySingle")}}</b
        >
        <b v-if="tagIndex === 1">
          {{$t("label_administration_wizard_newTagAddedAutomaticallyMultiple")}}
        </b>
      </div>
    </div>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";

export default {
  name: "TagToCreate",
  props: {
    tagToCreate: {
      type: Object,
      default: () => {},
    },
    tagIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  methods: {
    setTagToCreate(currentTag, field, newValue, index) {
      this.$store.dispatch("setTagToCreate", { field, value: newValue, index });
    },
    removeTagToCreate(index) {
      this.$store.dispatch("removeTagToCreate", index);
    },
  },
  computed: {
    ...mapGetters(["getTagsToCreate", "getAllStoreInfo"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
